module.exports = __webpack_public_path__ + "media/images/hitfun/welcome.socials.whatsapp-40c0a9f1a2ebf70fb2f3f224236e8dfd.svg";